import { useLocation, useParams } from "react-router-dom";
import { logDebug } from "../../utils/logging";

export default function RouteDebug({ label }: { label: string }) {
  const location = useLocation();
  const params = useParams();

  logDebug(`[${label}]`, {
    pathname: location.pathname,
    search: location.search,
    params,
  });

  return null;
}
